// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1Q8je","item":"PaymentsMobile_item__3p65k","label":"PaymentsMobile_label__3dZqR","amount":"PaymentsMobile_amount__2Jo6g"};